import DollarIcon from "assets/icons/DollarIcon";
import getCurrency from "helpers/currencyHelper";

export interface TableBalanceCompProps {
    title?: string;
    balance?: number;
    currency?: string;
}

export default function TableBalanceComp(props: TableBalanceCompProps) {
    const {balance, currency, title} = props;
    return (
        <div style={{padding: 12, display: "flex", alignItems: "center", gap: 40}}>
            <div style={{display: "flex", gap: 8, alignItems: "center"}}>
                <div
                    style={{
                        padding: 8,
                        borderRadius: 4,
                        backgroundColor: "#E9F2FF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <DollarIcon/>
                </div>
                <span style={{color: "#8F8F8F"}}>{title || "موجودی"}</span>
            </div>
            <div style={{display: "flex", gap: 4, alignItems: "center"}}>
        <span style={{fontSize: 22, direction: "ltr"}}>
          &nbsp;{Intl.NumberFormat().format(balance || 0)}
        </span>
                <span style={{color: "#8F8F8F"}}>&nbsp;{currency || getCurrency().defCur.en_title}</span>
            </div>
        </div>
    );
}
